<template>
  <v-app light>
    <!-- show menu and toolbar only if logged in -->
    <v-navigation-drawer
    v-if="loggedAlready && config.IS_USER_ACTIVE && config.IS_USER_LINKED"
    fixed
    v-model="drawer"
    app
    class="grey lighten-4"
    >
    <v-toolbar dense flat>
      <img class="pl-3" height="30" src="/static/img/logo/smartility_admin.png">
    </v-toolbar>
    <v-divider></v-divider>
    <!-- list of menuitems -->
    <v-list dense class="pt-0">
      <template v-for="(item, i) in items">
        <v-layout
        row
        v-if="item.heading"
        align-center
        :key="i"
        >
        <v-flex xs6>
          <v-subheader v-if="item.heading">
            {{ item.heading }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <!-- Admin's Corner redirects to the React admin portal directly — its children
           (Users, Roles & Access, Notification Log) now live there, so they're never
           rendered as an expandable submenu here. -->
      <v-list-tile v-else-if="isExternalMenuItem(item)" @click="handleMenuClick(item)">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content @click="saveTrackScreenAccess(item)">
          <v-list-tile-title>
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action class="justify-end" style="min-width: 24px;">
          <v-icon small class="grey--text text--darken-1" title="Opens in a new tab">open_in_new</v-icon>
        </v-list-tile-action>
      </v-list-tile>

      <!-- else if, menu with submenus -->
      <v-list-group v-else-if="item.children.length" v-model="item.model"
      :prepend-icon="item.icon"
      no-action >
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
      v-for="(child, i) in item.children"
      :key="i"
      :to="{path: '/' + child.url}"
      >
      <v-list-tile-action v-if="child.icon">
        <v-icon>{{ child.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content @click="saveTrackScreenAccess(child)">
        <v-list-tile-title>
          {{ child.text }}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list-group>

  <!-- else, just one level menu items -->
  <v-list-tile v-else @click="handleMenuClick(item)" :to="isExternalMenuItem(item) ? undefined : {path: '/' + item.url}">
    <v-list-tile-action>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content @click="saveTrackScreenAccess(item)">
      <v-list-tile-title>
        {{ item.text }}
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template> <!-- end of all menu items -->
      <!-- Static Upload Test link in navigation drawer -->
      <v-list-tile :to="{path: '/upload-test'}">
        <v-list-tile-action>
          <v-icon color="primary">science</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="primary--text font-weight-bold">
            Upload Test
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
<!-- available communities of this user -->
<v-card>
  <v-card-text class="pa-0">
    <div v-if="commList.length === 1" class="pa-3 title">
      <span>{{config.COMM_NAME}}</span>
    </div>
    <div v-else>
      <v-select class="pa-1 title"
      v-model="choosenComm"
      :items="commList.filter(rec => rec.is_active).map(rec => rec.comm_name)"
      @input="loadComm(commList.find(rec => rec.comm_name === choosenComm))"
      hide-details
      solo
      flat
      ></v-select>
    </div>
  </v-card-text>
</v-card>
</v-navigation-drawer>

<!-- tool/app bar -->
<v-toolbar
v-if="loggedAlready"
color="primary"
dark
fixed
app
dense
flat
>
<v-toolbar-title>
  <v-btn class="ma-0" icon @click.stop="drawer = !drawer" v-if="config.IS_USER_ACTIVE && config.IS_USER_LINKED && ($route.path.includes('/dashboard') || $route.path.includes('/visitors'))">
    <v-icon>menu</v-icon>
  </v-btn>
  <v-btn class="ma-0" icon @click.stop="$router.go(-1)" v-else-if="!$route.path.includes('/dashboard')">
    <v-icon>arrow_back</v-icon>
  </v-btn>
  <span>{{ $route.meta.title }}
    <span v-if="$route.path.includes('/visitors') && config.SECURITY_POST" class="warning--text px-2">
      [{{config.SECURITY_POST}}]
    </span>
  </span>
</v-toolbar-title>
<v-spacer></v-spacer>
<v-menu offset-y v-if="config.IS_USER_ACTIVE && config.IS_USER_LINKED">
  <v-btn icon slot="activator">
    <v-icon>account_circle</v-icon>
  </v-btn>
  <v-list>
    <v-list-tile :to="{path: '/profile'}">
      <v-list-tile-title>Profile</v-list-tile-title>
    </v-list-tile>
    <v-list-tile @click = "logout">
      <v-list-tile-title>Logout</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-menu>
</v-toolbar>
<!-- end of toolbar -->

<!-- content -->
<v-content class="white">
  <router-view></router-view>
</v-content>

<!-- bottom navigation for mobiles -->
<v-bottom-nav
fixed
:value="selectedItems.length && $vuetify.breakpoint.smAndDown && loggedAlready && config.IS_USER_ACTIVE && config.IS_USER_LINKED && $route.path.includes('/dashboard')"
:active.sync="curBot"
>
<template v-for="(item, i) in selectedItems">
  <!-- multilevel menu submenus as bottom sheets -->
  <v-bottom-sheet inset v-model="item.botModel">
    <v-btn slot="activator"
    flat
    :value="item.text"
    >
    <span class="secondary--text">{{ item.text }} </span>
    <v-icon class="accent--text">{{ item.icon }} </v-icon>
  </v-btn>
  <v-list>
    <v-list-tile
    v-for="(child, c) in item.children"
    :key="c"
    @click="item.botModel = false; handleMenuClick(child, item)"
    :to="isExternalMenuItem(child, item) ? undefined : {path: '/' + child.url}"
    >
    <v-list-tile-avatar>
      <v-icon class="accent--text">{{child.icon}}</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-title class="body-1 secondary--text">{{ child.text }}</v-list-tile-title>
  </v-list-tile>
</v-list>
</v-bottom-sheet>
</template>
</v-bottom-nav>

<v-dialog v-model="dlgPush" max-width="400px" persistent>
  <v-card flat>
    <v-card-title class="title">
      Wait!
    </v-card-title>
    <v-card-text  class="pt-0">
      <div class="subheading">You are not subscribed to push notification yet.</div>
      <div class="mt-3">
        Choose the option "allow" when you prompted next and start receiving important alerts from Integra Application.
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pt-1">
      <v-spacer></v-spacer>
      <v-btn flat @click.native="dlgPush=false">Remind Me Later</v-btn>
      <v-btn flat @click.native="reqBrowserPromptForPush()" color="accent">Proceed</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</v-app>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import { isLoggedIn, logout, getUserDevId, clearCache } from '@/utils/auth'
import axios from 'axios'

export default {
  data () {
    return {
      dialog: false,
      drawer: null,
      items: [],
      selectedItems: [],
      loggedAlready: null,
      curBot: null,
      bottomMenuItemsRes: ['My Unit', 'Community', 'Help Desk'],
      bottomMenuReqOrder: ['Management', 'Help Desk', 'Community', 'Facility', 'My Unit'],
      config: config,
      commList: [],
      curComm: {},
      choosenComm: '',
      dlgPush: false
    }
  },
  created () {
    // get current dir of app
    var curPath = require('path')
    config.APP_DIR = curPath.dirname(require.main.filename) + '/../'
    // check network connectivity
    this.axios.get(config.API_URL + '/getHandshakeFromServer/')
    .then(response => {
      // get supported countries
      this.axios.get(config.API_URL + '/getSupportedCountries/')
      .then(response => {
        config.SUPPORTED_COUNTRIES = response.data
      })

      // check for new community signup
      if (this.$router.currentRoute.path.startsWith('/create')) {
        this.$router.push('/welcome/create')
        // check for cache clearing requested by user
      } else if (this.$router.currentRoute.path.startsWith('/clear-cache')) {
        clearCache()
        alert('Application cache cleared successfully, please login again')
      } else {
        // existing user
        isLoggedIn()
        .then(response => {
          // set API key in header for further calls
          this.axios.defaults.headers.common = {'Authorization': 'Bearer ' + config.API_KEY}
          // load user details
          this.axios.get(config.API_URL + '/getUserByID/' + config.USER_ID)
          .then(response => {
            if (response.data.length > 0) {
              // common to an user
              config.CUST_ID = response.data[0].cust_id
              config.CUST_NAME = response.data[0].cust_name
              config.EMAIL_ID = response.data[0].contact_email
              config.AVATAR_URL = response.data[0].avatar_url

              // load list of communities associated to this user
              this.axios.get(config.API_URL + '/getCommByUserId/' + config.USER_ID)
              .then(response => {
                var idx = 0
                this.commList = response.data
                if (response.data.length > 1) {
                  // user has more than one community/unit, load last used or first linked on by default
                  config.LAST_COMM_ID = Number(localStorage.getItem('LAST_COMM_ID'))
                  if (config.LAST_COMM_ID && (this.commList.findIndex(rec => rec.comm_id === config.LAST_COMM_ID && ((rec.rel_status_list && rec.rel_status_list.includes('Linked') && rec.is_active) || (rec.is_other_user && rec.rel_status_if_other_user === 'Linked' && rec.is_active))) >= 0)) {
                    idx = this.commList.findIndex(rec => rec.comm_id === config.LAST_COMM_ID)
                  } else {
                    idx = response.data.findIndex(rec => (rec.rel_status_list && rec.rel_status_list.includes('Linked') && rec.is_active) || (rec.is_other_user && rec.rel_status_if_other_user === 'Linked' && rec.is_active))
                    if (idx < 0) {
                      idx = response.data.findIndex(rec => (rec.rel_status_list && rec.rel_status_list.includes('Delinked') || !rec.is_active) || (rec.is_other_user && (rec.rel_status_if_other_user === 'Delinked' || !rec.is_active)))
                    }
                  }
                  if (idx < 0) {
                    idx = 0
                  }
                }
                // load community and menu items as per the role
                this.loadComm(this.commList[idx])
              })
            } else {
              logout()
            }
          })
          .catch(err => {
            alert(err.response.data)
            return
          })
        })
        .catch(err => {
          // show welcome page
          console.log(err)
          this.$router.push('/')
        })
      }
    })
    .catch(err => {
      console.log(err)
      alert('Unable to connect to server, please check your internet connection')
    })
  },
  methods: {
    logout () {
      return logout()
    },
    loadMenu (emptyMenu = false) {
      // load menu items from db
      // admin overrides other roles
      var userRole = config.IS_ADMIN ? 'Administrator' : (!emptyMenu ? config.ROLE_NAME : 'Not Exist')
      this.axios.get(config.API_URL + '/getMenu/' + config.USER_ID + '/' + userRole + '/' + config.COMM_ID)
      .then(response => {
        this.items = response.data // all menus
        // create routes as well
        var curItem, curChild
        var rtArray = []
        var tmpComp
        var tmpSelItems = []
        for (var i = 0; i < this.items.length; i++) {
          curItem = this.items[i]
          if (curItem.url) {
            const rtCompNm = curItem.url.charAt(0).toUpperCase() + curItem.url.slice(1)
            tmpComp = () => import('@/components/' + rtCompNm)
            rtArray.push({
              name: rtCompNm,
              path: '/' + curItem.url,
              component: tmpComp,
              meta: { title: curItem.text }
            })
            rtArray.push({
              name: rtCompNm + ' ', // added a space just to get different name
              path: '/' + curItem.url + '/:action',
              component: tmpComp,
              meta: { title: curItem.text },
              props: true
            })
          }
          for (var j = 0; j < curItem.children.length; j++) {
            curChild = curItem.children[j]
            const rtCompNm = curChild.url.charAt(0).toUpperCase() + curChild.url.slice(1)
            tmpComp = () => import('@/components/' + rtCompNm)
            rtArray.push({
              name: rtCompNm,
              path: '/' + curChild.url,
              component: tmpComp,
              meta: { title: curChild.text }
            })
            rtArray.push({
              name: rtCompNm + ' ',
              path: '/' + curChild.url + '/:action',
              component: tmpComp,
              meta: { title: curChild.text },
              props: true
            })
          }
          // selected menus to display in the bottom
          if (config.IS_OTHER_USER) { // staffs
            // look for facility and add them
            if (curItem.text.includes('Facility')) {
              let tmpItem = Object.assign({}, curItem)
              tmpItem.text = 'Facility'
              tmpSelItems.push(tmpItem)
            } else if (!curItem.text.includes('My Unit') && this.bottomMenuItemsRes.indexOf(curItem.text) >= 0) {
              tmpSelItems.push(curItem)
            }
          } else { // resident
            if (this.bottomMenuItemsRes.indexOf(curItem.text) >= 0) {
              tmpSelItems.push(curItem)
            }
          }
        }

        this.$router.addRoutes(rtArray)

        if (config.IS_ADMIN) {
          // add management modules into bottom sheet
          let curItem = {text: 'Management', icon: 'more_vert', children: []}
          if (this.items.findIndex(rec => rec.text === 'Facility Management') >= 0 && !config.IS_OTHER_USER) {
            curItem.children.push({text: 'Facility Management', icon: 'engineering', url: 'facdash'})
          }
          if (this.items.findIndex(rec => rec.text === 'Accounts') >= 0) {
            curItem.children.push({text: 'Accounts', icon: 'money', url: 'invoicing'})
          }
          if (this.items.findIndex(rec => rec.text === 'Gate') >= 0) {
            curItem.children.push({text: 'Gate', icon: 'security', url: 'visitors'})
          }
          if (this.items.findIndex(rec => rec.text === 'Admin\'s Corner') >= 0) {
            curItem.children.push({text: 'Admin\'s Corner', icon: 'admin_panel_settings', url: 'users'})
          }
          tmpSelItems.push(curItem)
        }
        // sort the items for bottom sheet
        this.selectedItems = []
        if (tmpSelItems.length > 1) {
          let tmpIdx = 0
          this.bottomMenuReqOrder.forEach(rec => {
            tmpIdx = tmpSelItems.findIndex(curItem => curItem.text === rec)
            if (tmpIdx >= 0) {
              this.selectedItems.push(tmpSelItems[tmpIdx])
            }
          })
        }

        // set flag to show menu
        this.loggedAlready = true

        // and go to dashboard / payments page if call back received from PG
        if (this.$router.currentRoute.path.includes('/dashboard')) {
          /* helps to catch the event when user wants to change his community
          when he is associated to more than one community. Refresh the dashboard accordingly */
          this.$router.push('/dashboard/' + config.COMM_ID)
        } else if (this.$router.currentRoute.path.includes('invpay/pgcallback')) {
          this.$router.push(this.$router.currentRoute.path)
        } else {
          if (config.ROLE_NAME.toLowerCase().includes('security')) { // helps security to directly go to visitors screen
            this.$router.push('/visitors/')
          } else {
            this.$router.push('/dashboard/')
          }

          // prompt for push subscription if needed as user might be visiting this app first time
          this.checkForPushSubsciption()
          .then(sub => {
            if (sub) {
              this.updateSubscriptionOnServer(sub)
            } else {
              // show the app specific dialog for push subscription
              this.dlgPush = true
            }
          })
          .catch(err => {
            console.log(err)
          })
        }
      })
      .catch(error => {
        alert(error.response.data)
        return
      })
    },
    loadComm (curComm) {
      // remember last used community
      config.LAST_COMM_ID = curComm.comm_id
      localStorage.setItem('LAST_COMM_ID', config.LAST_COMM_ID)

      // load community global config
      this.choosenComm = curComm.comm_name
      config.COMM_ID = curComm.comm_id
      config.COMM_NAME = curComm.comm_name
      config.COMM_COUNTRY_CODE = curComm.country_code
      config.CURRENCY = curComm.currency_symbol
      handy.COMM_COUNTRY_CODE = curComm.country_code
      handy.CURRENCY = curComm.currency_symbol
      config.IS_TAX_APP = curComm.is_tax_app
      config.IS_INV_CLASS = curComm.is_inv_class
      config.TAX_INV_CLASS = curComm.tax_inv_class
      config.NON_TAX_INV_CLASS = curComm.non_tax_inv_class
      config.TAX_INV_CLASS_CHAR = 'T'
      config.NON_TAX_INV_CLASS_CHAR = 'N'
      config.IS_COVID_CHECK_ENABLED = curComm.is_covid_check_enabled
      config.IS_BACKOFFICE_COMM = curComm.is_backoffice_comm
      // notification settings
      config.SMS_FOR_EASYPASS = curComm.sms_for_easypass

      // users role in this community
      config.IS_OTHER_USER = curComm.is_other_user === 1
      config.ROLE_NAME = curComm.role_name
      config.IS_MC_MEMBER = curComm.is_mc_member === 1
      config.IS_ADMIN = curComm.is_admin === 1
      config.IS_USER_ACTIVE = curComm.is_active === 1
      config.HIDE_CONTACT = curComm.hide_contact === 1

      // users units
      config.ALL_UNITS = [{}]
      config.UNITS = [{}]
      config.UNIT_ID_LIST = []
      config.USER_HAS_MORE_UNITS = false
      config.PRIVATE_UNITS = []
      config.PRIVATE_UNIT_ID_LIST = []
      config.USER_HAS_MORE_PRIVATE_UNITS = false
      if (curComm.rel_status_list && !curComm.rel_status_list.includes('Linked')) {
        if (curComm.rel_status_list.includes('Pending Approval')) {
          alert('Your joining request is currently pending for approval, please come back later once it is approved')
        } else {
          alert('Sorry, you are currently delinked from this community, please contact your admin if you do not expect to see this message')
        }
        this.loadMenu(true)
        return
      }
      if (!config.IS_OTHER_USER) {
        // users unit (one or more in this community)
        this.axios.get(config.API_URL + '/getUnitsByUserId/' + config.USER_ID + '/' + config.COMM_ID)
        .then(response => {
          config.ALL_UNITS = response.data
          config.UNITS = config.ALL_UNITS.filter(rec => rec.rel_status === 'Linked')
          // check user has more than one unit in this community
          config.USER_HAS_MORE_UNITS = config.UNITS.length > 1
          if (config.UNITS.length) {
            config.UNIT_ID_LIST = config.UNITS.map(rec => rec.unit_id)
          }

          // list of units which needs privacy (used mostly in security module)
          config.UNITS.forEach(unit => {
            if (unit.is_rented) {
              if (unit.ownership.toLowerCase().includes('tenant')) {
                // rented units are private to tenants
                config.PRIVATE_UNITS.push(unit)
              }
            } else {
              // not-rented, not private to anyone
              config.PRIVATE_UNITS.push(unit)
            }
          })
          config.PRIVATE_UNIT_ID_LIST = config.PRIVATE_UNITS.map(rec => rec.unit_id)
          config.USER_HAS_MORE_PRIVATE_UNITS = config.PRIVATE_UNIT_ID_LIST.length > 1

          // check for atleast one linked unit
          config.IS_USER_LINKED = config.UNITS.length > 0
          config.IS_USER_EMPOWERED = config.IS_ADMIN || config.IS_FM || (curComm.role_name === 'Helpdesk Executive')
          this.loadMenu()
        })
        .catch(error => {
          alert(error.response.data)
          return
        })
      } else {
        config.IS_FM = curComm.role_name.includes('Facility Manager')
        config.UNITS[0].rel_status = curComm.rel_status_if_other_user
        config.UNITS[0].rej_reason = curComm.rej_reason_if_other_user
        config.UNITS[0].ownership = ''
        config.ALL_UNITS = config.UNITS
        config.UNIT_ID_LIST = []
        config.IS_USER_LINKED = curComm.rel_status_if_other_user === 'Linked'
        config.IS_USER_EMPOWERED = config.IS_ADMIN || config.IS_FM || (curComm.role_name === 'Helpdesk Executive')
        this.loadMenu()
      }

      // get community subscriptions and settings
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommSubscriptions/', qry)
      .then(response => {
        config.COMM_CONFIG = response.data[0]
        console.log(config.COMM_CONFIG)
      })

      // get the vendor id if the vendor who manages this community uses Smartility BackBone
      this.axios.get(config.API_URL + '/getCommFMVendorWithBB/' + config.USER_ID + '/' + config.COMM_ID)
      .then(response => {
        if (response.data.length) {
          config.FM_VENDOR_ID = response.data[0].vendor_id
          config.FM_VENDOR_NAME = response.data[0].vendor_name
          config.IS_BB_VENDOR = true
        } else {
          config.FM_VENDOR_ID = 1 // default vendor is uniservice for fm module's config purpose
          config.FM_VENDOR_NAME = ''
          config.IS_BB_VENDOR = false
        }
      })
    },
    // function to check for valid push subscription
    checkForPushSubsciption () {
      return navigator.serviceWorker.getRegistrations()
      .then(regs => {
        if (regs.length) {
          return regs[0].pushManager.getSubscription()
        } else {
          throw Error('Service worker is not installed yet')
        }
      })
    },
    reqBrowserPromptForPush () {
      // hide the app specific custom dialog abd show the browser prompt
      this.dlgPush = false
      this.updateSubscriptionOnServer()
    },
    updateSubscriptionOnServer (subs = null) {
      if (!subs) {
        // get fresh subscription along with permission from user
        console.log('Getting fresh push subscription')
        this.askPermission()
        .then(res => {
          try {
            const subscribeOptions = {
              userVisibleOnly: true,
              applicationServerKey: this.urlB64ToUint8Array(
                'BM-8M9QH1g6T9RerpYi4rY8L3n_NG9oinXge1PahtYlrW4_fmlYZYUgem4_w6MLdZzRdxVTj9k5YFiyfKXUXHbw'
              )
            }
            navigator.serviceWorker.getRegistrations()
            .then(async regs => {
              subs = await regs[0].pushManager.subscribe(subscribeOptions)
              this.sendSubscription(subs, 'granted')
            })
          } catch (e) {
            console.log('Error subscribing for push:', e)
            this.sendSubscription(subs, 'error')
          }
        })
        .catch(err => {
          // user either skipped or blocked notification.
          this.sendSubscription(subs, err.message)
        })
      } else {
        // associate with existing subscription
        console.log('Associating existing subscription to this user')
        this.sendSubscription(subs, 'granted')
      }
    },
    askPermission () {
      return new Promise((resolve, reject) => {
        const permissionResult = Notification.requestPermission((result) => {
          resolve(result)
        })
        if (permissionResult) {
          permissionResult.then(resolve, reject)
        }
      })
      .then((permissionResult) => {
        if (permissionResult !== 'granted') {
          throw new Error(permissionResult)
        }
      })
    },
    sendSubscription (subs, subStatus) {
      if (subStatus === 'denied') {
        alert('It seems you had denied the permission earlier,\nIn Mobile: Go to settings->Apps->Uniservice app->Notification->Unblock\nIn Desktop: Go to browser\'s settings->Advanced->Privacy and security->Site settings->Notifications->Enable notifications for Uniservice App')
      }
      console.log('Sending subscription to server:' + subStatus)
      var req = {
        user_id: config.USER_ID,
        push_channel: 'W',
        push_sub: JSON.stringify(subs),
        user_device_id: getUserDevId(),
        sub_status: subStatus
      }
      axios.post(config.API_URL + '/push-sub/', req)
      .catch(err => {
        console.log('Error storing subscription:', err.response.data)
      })
    },
    urlB64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/')

      const rawData = atob(base64)
      const outputArray = new Uint8Array(rawData.length)

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    },
    isExternalMenuItem (item, parent) {
      // Matches either the "Admin's Corner" item itself (its own activator row, or the
      // single synthetic bottom-nav shortcut), or one of its children (Users, Roles &
      // Access, Notification Log) — those only carry their own text, so we also need
      // to know their parent group to recognize they belong to Admin's Corner.
      return item.text === 'Admin\'s Corner' || (!!parent && parent.text === 'Admin\'s Corner')
    },
    handleMenuClick (item, parent) {
      if (!this.isExternalMenuItem(item, parent)) {
        return
      }
      var childWindow = window.open(config.ADMIN_CORNER_URL, '_blank')
      if (!childWindow) {
        return
      }
      var targetOrigin = new URL(config.ADMIN_CORNER_URL).origin
      var handleReactReady = function (event) {
        if (event.origin !== targetOrigin || !event.data || event.data.type !== 'REACT_READY') {
          return
        }
        childWindow.postMessage({
          type: 'VUE_AUTH_PAYLOAD',
          payload: {
            token: config.API_KEY,
            comm_id: config.COMM_ID,
            user_id: config.USER_ID
          }
        }, targetOrigin)
        window.removeEventListener('message', handleReactReady)
      }
      window.addEventListener('message', handleReactReady)
    },
    saveTrackScreenAccess (curItem) {
      curItem.vendor_id = config.FM_VENDOR_ID
      curItem.user_id = config.USER_ID
      curItem.comm_id = config.COMM_ID
      curItem.screen_id = curItem.screen_no
      curItem.is_sv_user = false
      this.axios.post(config.API_URL + '/trackScreenAccess/', curItem)
      .then(response => {
      })
      .catch(err => {
        alert(err)
      })
    }
  }
}
</script>

<style>
.v-card__text {
  padding: 16px !important;
}
.pa-0 {
  padding: 0px !important;
}
.pa-3 {
  padding: 16px !important;
}
</style>


// WEBPACK FOOTER //
// App.vue?e391b5d4